import SEOHead from '../../components/base/SEOHead';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import AboutHero from './components/AboutHero';
import AboutStory from './components/AboutStory';
import AboutMission from './components/AboutMission';
import AboutFounders from './components/AboutFounders';
import AboutAwards from './components/AboutAwards';
import AboutCTA from './components/AboutCTA';

export default function AboutPage() {
  const baseUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "name": "About KaliKare Homecare",
      "description": "Learn about KaliKare\u2019s story, mission, and founders. Founded by Yana and Yasmeen, we are dedicated to providing compassionate, personalized home care services with a focus on quality, dignity, and respect for every client.",
      "url": `${baseUrl}/about`,
      "mainEntity": {
        "@type": "Organization",
        "name": "KaliKare Homecare",
        "url": baseUrl,
        "logo": "https://kalikarehomecare.com/wp-content/uploads/2020/05/ik.jpg",
        "description": "KaliKare Homecare is a compassionate home care agency based in Radnor, PA, dedicated to delivering personalized, client-centered care services.",
        "founder": [
          {
            "@type": "Person",
            "name": "Yana",
            "jobTitle": "Co-Founder"
          },
          {
            "@type": "Person",
            "name": "Yasmeen",
            "jobTitle": "Co-Founder"
          }
        ],
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "201 King of Prussia Rd, Suite 650",
          "addressLocality": "Radnor",
          "addressRegion": "PA",
          "postalCode": "19087",
          "addressCountry": "US"
        },
        "telephone": "+1-833-438-5542",
        "email": "info@kalikarehomecare.com"
      }
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": baseUrl
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "About",
          "item": `${baseUrl}/about`
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <SEOHead
        title="About KaliKare – Our Story, Mission & Founders | Radnor, PA"
        description="Learn about KaliKare Homecare\u2019s story, mission, and founders. Founded by Yana and Yasmeen, we are dedicated to providing compassionate, personalized home care services with a focus on quality, dignity, and respect for every client in Radnor, PA."
        canonical="/about"
        jsonLd={jsonLd}
      />
      <Navbar />
      <AboutHero />
      <AboutStory />
      <AboutMission />
      <AboutFounders />
      <AboutAwards />
      <AboutCTA />
      <Footer />
    </div>
  );
}
